import React, { useState, useEffect } from 'react';

export const profileData1 = 
    {
        'id': 1,
        'name' : {
            'firstName':'Anna',
            'middleName':'Janet',
            'lastName':'Smith'
        },
        'idMe': {
            'status':'verified'
        }, 
        'basicInfo': {
            'catchphrase':'I am really cool to talk to... some other cheesy lines. blah blah blah blah blah blah blah blah  blah blah',
            'sex':'woman',
            'DOB':'01/01/1985',
            'age': '30',
            'maritalStatus':'Single',
            'education':'Bachelor of Science',
            'height':'5',
            'hairColor':'Brown',
            'eyeColor':'Hazel',
            'bodyType':'Athletic',
            'sexualOrientation':'Female',
            'location':'Miami, FL',
            'politicalAffiliation':'Democratic',
            'religiousAffiliation':'Christian',
            'placeOfBirth':'Ohio',
            'branchOfServiceAffiliation':'Army',
            'dutyStatus':'Active',
            'currentEmployment':'Some Cool Place'
        },
        'lookingForPreferences': {
            'relationship':'Short Term Relationship',
            'sexualOrientation':'Male',
            'ageHigh':'40',
            'ageLow':'20',
            'height':'5',
            'hairColor':'Brown',
            'eyeColor':'Blue',
            'bodyType':'Athletic, Slim, Fit',
            'branchOfServiceAffiliation':'Army',
            'activeStatus':'Veteran',
            'searchLocation': '52317',
            'distanceFromSearchLocation': '100',
        }
    }

    export const profileData2 = 
    {
        'id': 1,
        'name' : {
            'firstName':'Jane',
            'middleName':'Janet',
            'lastName':'Smith'
        },
        'idMe': {
            'status':'verified'
        }, 
        'basicInfo': {
            'catchphrase':'I am really cool to talk to... some other cheesy lines. blah blah blah blah blah blah blah blah  blah blah',
            'sex':'woman',
            'DOB':'01/01/1985',
            'age': '30',
            'maritalStatus':'Single',
            'education':'Bachelor of Science',
            'height':'5',
            'hairColor':'Brown',
            'eyeColor':'Hazel',
            'bodyType':'Athletic',
            'sexualOrientation':'Female',
            'location':'Miami, FL',
            'politicalAffiliation':'Democratic',
            'religiousAffiliation':'Christian',
            'placeOfBirth':'Ohio',
            'branchOfServiceAffiliation':'Army',
            'dutyStatus':'Active',
            'currentEmployment':'Some Cool Place'
        },
        'lookingForPreferences': {
            'relationship':'Short Term Relationship',
            'sexualOrientation':'Male',
            'ageHigh':'40',
            'ageLow':'20',
            'height':'5',
            'hairColor':'Brown',
            'eyeColor':'Blue',
            'bodyType':'Athletic, Slim, Fit',
            'branchOfServiceAffiliation':'Army',
            'activeStatus':'Veteran',
            'searchLocation': '52317',
            'distanceFromSearchLocation': '100',
        }
    }